const selectItem = document.querySelector('#product-select')
const productQty = document.querySelector('#product-quantity')
const qtyWrapper = document.querySelector('.form-quantity__body')

if (selectItem) {
  selectItem.onchange = function () {
    const option = selectItem.selectedOptions
    if (option.length) {
      const dataInventoryPolicy = option[0].getAttribute(
        'data-inventory-policy'
      )
      let dataQty = parseInt(option[0].getAttribute('data-qty'))
      if (dataQty > 0 || dataInventoryPolicy === 'continue') {
        qtyWrapper.classList.remove('hide-qty')
      } else {
        qtyWrapper.classList.add('hide-qty')
      }
      if (dataQty > 50) {
        dataQty = 50
      }
      productQty.innerHTML = null
      for (var i = 1; i <= dataQty; i++) {
        let newOption = document.createElement('option')
        newOption.value = i
        newOption.textContent = i
        productQty.appendChild(newOption)
      }
    }
  }
}
